import { ArdoqId, TimelineField } from '@ardoq/api-types';
import {
  FieldsAndItemsSourceData,
  RelevantCompontsScopeDataMap,
  TimelineViewGraphHierarchy,
  TimelineViewSettings,
  ViewRelevantWorkspaceScopeData,
  WorkspaceAndFieldsRegistry,
} from '../types';
import { removeIrrelevantNodesBasedOnSelectedFields } from './calculations';
import { timelineViewModelOperations } from './viewModelOperations';

type GetItemsSourceDataForWorkspaceModeArgs = {
  viewGraphHierarchy: TimelineViewGraphHierarchy;
  selectedFields?: TimelineField[];
  isFilterBySelectedFields?: boolean;
  contextComponentId: ArdoqId;
  viewSettings: TimelineViewSettings;
  viewRelevantWorkspacesScopeData: ViewRelevantWorkspaceScopeData[];
  viewRelevantComponentsScopeData: RelevantCompontsScopeDataMap;
  workspaceAndFieldsRegistry: WorkspaceAndFieldsRegistry;
  hasGrouping: boolean;
  hasRootGroupsInContextOnlyFeature?: boolean;
};

export const getFieldsAndItemsSourceDataForWorkspaceMode = ({
  viewGraphHierarchy,
  selectedFields,
  isFilterBySelectedFields,
  contextComponentId,
  viewSettings,
  viewRelevantWorkspacesScopeData,
  viewRelevantComponentsScopeData,
  hasGrouping,
  hasRootGroupsInContextOnlyFeature,
  workspaceAndFieldsRegistry,
}: GetItemsSourceDataForWorkspaceModeArgs): FieldsAndItemsSourceData => {
  const {
    orderedSelectedDateRangeFields,
    orderedSelectedMilestoneFields,
    relevantDateRangeFieldsWithWorkspaceNames,
    relevantMilestoneFieldsWithWorkspaceNames,
  } = timelineViewModelOperations.getFieldsMetaData({
    selectedFields,
    isFilterBySelectedFields,
    viewRelevantWorkspacesScopeData,
    viewSettings,
    workspaceAndFieldsRegistry,
  });

  // select all component types in all workspaces, that have at least one field which is selected by user
  const allSelectedFieldIds = new Set([
    ...orderedSelectedDateRangeFields.flatMap(
      ({ dateTimeFields: { start, end } }) => [start._id, end._id]
    ),
    ...orderedSelectedMilestoneFields.map(({ _id }) => _id),
  ]);

  const { filteredViewGraphHierarchy, filteredStartSetNodes } =
    removeIrrelevantNodesBasedOnSelectedFields({
      viewRelevantWorkspacesScopeData,
      allSelectedFieldIds,
      viewGraphHierarchy,
      hasGrouping,
      viewRelevantComponentsScopeData,
      contextComponentId,
      hasRootGroupsInContextOnlyFeature,
    });

  return {
    viewGraphHierarchy: filteredViewGraphHierarchy,
    startSetNodes: filteredStartSetNodes,
    orderedSelectedDateRangeFields,
    orderedSelectedMilestoneFields,
    relevantDateRangeFieldsWithWorkspaceNames,
    relevantMilestoneFieldsWithWorkspaceNames,
  };
};
